import { Component, Inject } from "@angular/core";
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/legacy-dialog";

export interface DialogData {
    title: string;
    message: string;
    isError: boolean;
    isConfirmDialog: boolean
}

@Component({
    selector: 'message-dialog-modal',
    templateUrl: 'message-dialog-modal.html',
    styleUrls: ['message-dialog-modal.scss']
})
export class MessageDialogModalDialog {

    isConfirmDialog = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) {
        this.isConfirmDialog = data.isConfirmDialog;
    }
}